import React, { forwardRef } from 'react';
import Toolbar, { TOOLBAR_GROUP } from './Toolbar';

/**
 * THE LIST-PAGE TOOLBAR — the Breakdown's composition, once (extracted
 * 2026-10-25; owner, building Timesheets: *"take insperation from the breakdown
 * page on wher teh search bar goes etc. again COMMON CODE!"* and *"its becoming
 * a pain to have to design the searchbox dimensions and page padding, tab lyout
 * and design etc etc"*).
 *
 *   [🔍 search] [picker] [tabs] [Group ▾]                       [Actions ▾]
 *   [All · Not entered (3) · Conflicting (1) · …]   ← the status row
 *
 * Slots, each a FINISHED node (the component reads no data and no permission):
 *  - `search`  — a `ui/SearchInput`.
 *  - `picker`  — a box-style picker (`ui/WeekPicker`), after the search.
 *  - `tabs`    — a `ui/Tabs` in `bare` mode.
 *  - `group`   — the `Group ▾` (`ui/GroupControl`), in its own
 *    `TOOLBAR_GROUP`. 🔑 Passing `null` still renders the (empty) group wrapper
 *    and OMITTING the prop renders nothing — the Breakdown always rendered the
 *    wrapper, and its DOM is byte-identical on this component.
 *  - `actions` — `ui/Toolbar`'s `rightSlot` (`ml-auto`): an `Actions ▾`.
 *  - `statusRow` — the status-filter strip (`ui/Tabs` bare, with counts), on a
 *    row of its OWN inside the sticky bar (`order-last basis-full`), desktop
 *    only, scrolling sideways inside itself rather than widening the page —
 *    the Breakdown's status strip, measured there. `statusRowRef` /
 *    `statusRowTestId` reach its wrapper.
 *  - `phone` — below `md` the caller hands the whole phone header
 *    (`MobileTabSearchRow`); when given it REPLACES every desktop slot.
 * Every other prop (`marginClassName`, `className`, `data-*`) passes to
 * `ui/Toolbar`, and the forwarded ref is the toolbar's (`useStickyToolbar`).
 *
 * The order is DOM order and DOM order is the layout: `TOOLBAR_SHELL` is one
 * `flex-wrap` row. Do not add a slot by appending JSX at a call site — add it
 * here, so every list page gets it in the same place.
 */
export const LIST_PAGE_STATUS_ROW =
  'hidden md:block order-last basis-full min-w-0 overflow-x-auto overflow-y-hidden';

const ListPageToolbar = forwardRef(function ListPageToolbar(
  {
    search, picker, tabs, actions, statusRow, statusRowRef, statusRowTestId, phone, ...rest
  },
  ref
) {
  const hasGroup = Object.prototype.hasOwnProperty.call(rest, 'group');
  const { group, ...toolbarProps } = rest;
  return (
    <Toolbar ref={ref} rightSlot={actions} {...toolbarProps}>
      {phone || (
        <>
          {search}
          {picker}
          {tabs}
          {hasGroup ? <div className={TOOLBAR_GROUP}>{group}</div> : null}
          {statusRow ? (
            <div ref={statusRowRef} className={LIST_PAGE_STATUS_ROW} data-testid={statusRowTestId}>
              {statusRow}
            </div>
          ) : null}
        </>
      )}
    </Toolbar>
  );
});

export default ListPageToolbar;
